import type { Locale } from "@/lib/i18n";

/**
 * Anasayfa divider'ında tek tek, sırayla akan tanıtım cümleleri.
 * Kaynak: dentOS.pdf akışı — TR çeviri + EN orijinal.
 * `hi` = vurgulanan (accent renkli) kısım.
 */
export type RevealLine = { pre?: string; hi?: string; post?: string };

export const REVEAL_SCRIPT: Record<Locale, RevealLine[]> = {
  tr: [
    { pre: "Yardıma mı ihtiyacınız var?" },
    { hi: "kliniğinizde" },
    { hi: "diş hekiminizde" },
    { hi: "hastanenizde" },
    { hi: "hastanızda" },
    { hi: "raporlarınızda" },
    { hi: "büyümenizde" },
    { pre: "belki ..?" },
    { hi: "gülüşünüzde" },
    { pre: "bizde ", hi: "oravity", post: " var" },
    { pre: "peki ya sizde ?" },
    { pre: "oravity", post: " sizinle." },
    { pre: "oravity", post: " — klinikteki göz" },
    { pre: "oravity", post: " — dental çözümler" },
  ],
  en: [
    { pre: "need help ?" },
    { pre: "on your ", hi: "clinic" },
    { pre: "on your ", hi: "dentist" },
    { pre: "on your ", hi: "hospital" },
    { pre: "on your ", hi: "patient" },
    { pre: "on your ", hi: "report" },
    { pre: "on your ", hi: "growth" },
    { pre: "maybe ..?" },
    { pre: "on your ", hi: "smile" },
    { pre: "we have ", hi: "oravity" },
    { pre: "do you have ?" },
    { pre: "oravity", post: " is with you." },
    { pre: "oravity", post: " — eye in the clinic" },
    { pre: "oravity", post: " — dental solutions" },
  ],
};
